import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';

const capitalize = (text) => text.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
const SKIPPED_SEGMENTS = ['edit', 'new', 'admin'];

const Breadcrumbs = () => {
  const location = useLocation();

  const crumbs = useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);

    let baseCrumbs = segments
      .map((segment, index) => {
        const path = '/' + segments.slice(0, index + 1).join('/');
        const label =
          /^\d+$/.test(segment) && location.state
            ? Object.values(location.state)[0] || capitalize(decodeURIComponent(segment))
            : capitalize(decodeURIComponent(segment));
        return { path, label, raw: segment };
      })
      .filter(({ raw }) => !SKIPPED_SEGMENTS.includes(raw));

    const idIndex = baseCrumbs.findIndex(c => /^\d+$/.test(c.raw));
    if (location.state?.storeName && location.state?.storeId && idIndex > 0) {
      baseCrumbs.splice(idIndex, 0, {
        path: `/admin/stores/${location.state.storeId}`,
        label: location.state.storeName,
        raw: `store-${location.state.storeId}`,
      });
    }

    return [
      {
        path: '/admin',
        label: 'Home',
        isLast: false
      },
      ...baseCrumbs.map((crumb, index, arr) => ({
        ...crumb,
        isLast: index === arr.length - 1
      }))
    ];
  }, [location.pathname, location.state]);

  return (
    <MUIBreadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {crumbs.map(({ label, path, isLast, raw }) => {
        const isStoreCrumb = raw?.startsWith('store-');

        return isLast || isStoreCrumb ? (
          <Typography key={path} color="text.primary">
            {label}
          </Typography>
        ) : (
          <Link key={path} to={path} style={{ textDecoration: 'none' }}>
            {label}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;